/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-16 17:40:09
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-17 17:32:43
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { IconFont } from '@src/features/common';
import './SFCSuccess.less';

export interface ISFCSuccessProps {}
type Props = ISFCSuccessProps;

export function SFCSuccess(props: Readonly<Props>) {
  return (
    <div className="common-presenter k-common-success">
      <IconFont type="icon-success" className="relase__icon" />
      <p className="relase__success__txt">发布成功!</p>
      <div className="relase__success__link">
        <Link to={`/personal`}>
          去查看我的发布
          <IconFont type="icon-right" />
        </Link>
      </div>
    </div>
  );
}

export default SFCSuccess;
